export const formatExpiry = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
};

export const formatInterviewStatus = (status) => {
  if (!status) return 'Unknown';
  if (status === 'completed') return 'Completed';
  if (status === 'in_progress') return 'In Progress';
  if (status === 'pending') return 'Pending';

  return status
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const formatInterviewDuration = (interview) => {
  if (!interview || interview.status === 'pending' || interview.status === 'not_started' || interview.status === 'scheduled') {
    return 'N/A';
  }

  if (interview.started_at && interview.ended_at) {
    const startedAtStr = interview.metadata?.actual_started_at || interview.started_at;
    const start = new Date(startedAtStr);
    const end = new Date(interview.ended_at);
    const durationMs = end - start;

    if (Number.isFinite(durationMs) && durationMs > 0) {
      const totalSecs = Math.round(durationMs / 1000);
      const mins = Math.floor(totalSecs / 60);
      const secs = totalSecs % 60;
      if (mins > 0 && secs > 0) {
        return `${mins}m ${secs}s`;
      } else if (mins > 0) {
        return `${mins}m`;
      } else {
        return `${secs}s`;
      }
    }
  }

  if (Number.isFinite(Number(interview?.duration_minutes)) && Number(interview.duration_minutes) > 0) {
    const floatMins = Number(interview.duration_minutes);
    const totalSecs = Math.round(floatMins * 60);
    const mins = Math.floor(totalSecs / 60);
    const secs = totalSecs % 60;
    if (mins > 0 && secs > 0) {
      return `${mins}m ${secs}s`;
    } else if (mins > 0) {
      return `${mins}m`;
    } else {
      return `${secs}s`;
    }
  }

  return 'N/A';
};

export const getInterviewScore = (interview) => {
  const effectiveScore = interview?.feedback?.detailed_breakdown?.effective_score;
  const totalScore = interview?.feedback?.total_score ?? interview?.total_score;
  const score = effectiveScore ?? totalScore;

  return Number.isFinite(Number(score)) ? Math.round(Number(score)) : null;
};
